import React from "react";
import FormSubmitted from "../../shared/components/FormSubmitted";

/**
 * The pre-consultation form's thank-you: the shared screen, and the one
 * sentence on it that is this form's own.
 *
 * No brand name in the line, unlike the enquiry form's. This link was sent to
 * one client by a practitioner they have already spoken to — they know whose
 * form they have just filled in, and naming the brand back at them at the end
 * of it reads as a mail merge.
 *
 * It plays the same tick the enquiry form ends on. An earlier version drew a
 * static one, on the argument that this form is long and a mark that is simply
 * there says as much without anybody waiting through it — but the two forms
 * arrive on the same phone from the same practitioner, and looking alike
 * matters more here than the second it costs.
 */
const PreconsultationSubmitted: React.FC = () => (
  <FormSubmitted message="Thanks for sharing your details, will get back to you shortly." />
);

export default PreconsultationSubmitted;
